import { Component, OnInit, inject, ChangeDetectionStrategy, signal, input, OnChanges, SimpleChanges } from '@angular/core';
import {Router} from '@angular/router';
import {PersonLogin} from '../person/person-login';
import {OrganizationAddressService} from '../services/organization-address-service';
import {OrganizationService} from '../services/organization-service';
import {PersonLoginService} from '../services/person-login-service';
import {OrganizationAddress} from './organization-address';
import {OrgAddressDetailComponent} from './org-address-detail.component';
import {OrgAddressGridComponent} from './org-address-grid.component';

import {MatIcon} from '@angular/material/icon';
import {MatButton} from '@angular/material/button';

@Component({
    selector: 'organization-addresses',
    templateUrl: './organization-addresses.component.html',
    styleUrls: ['./organization-addresses.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatButton, MatIcon, OrgAddressGridComponent, OrgAddressDetailComponent]
})
export class OrganizationAddressesComponent implements OnInit, OnChanges {
  private readonly personLoginService = inject(PersonLoginService);
  private readonly addressService = inject(OrganizationAddressService);
  private readonly organizationService = inject(OrganizationService);
  private readonly router = inject(Router);


  public personLogin!: PersonLogin;
  readonly organizationId = input.required<string>({ alias: 'organization-id' });
  readonly addresses = signal<OrganizationAddress[]>(undefined!);
  readonly addressesLoaded = signal<boolean>(undefined!);
  public selectedAddress!: OrganizationAddress;

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['organizationId'].firstChange) {
      this.initialize();
    }
  }

  private initialize(): void {
    const idString: string = this.organizationId();
    if (idString && idString.length > 0) {
      this.organizationService.getOrganization(idString).subscribe(result => {
        let userOrg = this.personLogin.person.primaryOrgUnitId;
        if (this.personLogin.roles.length === 0 && result.orgUnitId !== userOrg && result.controllingOrgId !== userOrg) {
          this.backToOrganizationMaster();
        } else {
          this.loadOrganizationAddresses();
        }
      });
    } else {
      this.backToOrganizationMaster();
    }
  }

  public newAddress(): void {
    this.addressesLoaded.set(false);
    this.selectedAddress = new OrganizationAddress();
    this.selectedAddress.typeCode = "SHIPTO";
    this.selectedAddress.createUser = this.personLogin.person.userLogin;
    this.selectedAddress.orgUnitId = this.organizationId();
  }

  public refreshList(): void {
    this.addressesLoaded.set(false);
    this.selectedAddress = null!;
    this.loadOrganizationAddresses();
  }

  private loadOrganizationAddresses(): void {
    this.addressService.getOrganizationAddresses(this.organizationId()).subscribe(results => {
      this.addresses.set(results);
      this.addressesLoaded.set(true);
    });
  }

  private backToOrganizationMaster(): void {
    this.router.navigate(['organization']);
  }

  public backToOrganizationDetail(): void {
    this.router.navigate(['organization/' + this.organizationId()]);
  }

  ngOnInit(): void {
    if (this.personLoginService.isOutsideEngineer()) {
      this.router.navigate(['ratings']);
    } else {
      this.personLogin = this.personLoginService.getCachedLogin()!;
      this.initialize();
    }
  }

}
